export enum Locale {
	EN = 'en-US',
}

export enum NormalizedLocale {
	EN = 'en-us',
}
